import {dqs} from '../lib/util'
import {hide, show} from '../lib/ui'

export async function dashboard() {
  const {email, stripe, encrypted_data} = JSON.parse(sessionStorage.user)

  const donate_btn = dqs('#donate_btn')
  const update_donation_btn = dqs('#update_donation_btn')
  const update_cc_btn = dqs('#update_cc_btn')

  // with stripe, we can check different properties and determine the type of member regarding donations
  const {subscription, payment_methods} = stripe
  const has_stripe_subscription = subscription !== null
  const has_stripe_card = payment_methods.length > 0

  // we start with all buttons hidden
  hide('#donate_btn', '#update_donation_btn', '#update_cc_btn')

  if(!has_stripe_subscription) {
    const donation_base_link = donate_btn.href
    if(encrypted_data) {
      donate_btn.href = `${donation_base_link}&member=${encrypted_data}`
    }

  	show('#donate_btn')
  }

  if(has_stripe_card) {
    show('#update_cc_btn')
  }

  if(has_stripe_subscription) {
    show('#update_donation_btn')
  }
}
